import type { SVGProps } from "react";

const baseProps: SVGProps<SVGSVGElement> = {
    className: "icon",
    viewBox: "0 0 1024 1024",
    width: 48,
    height: 48,
    "aria-hidden": true
};

/** 全屏状态下的退出图标，对应旧 `fei-quan-ping.vue`。 */
export function ExitFullscreenIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg {...baseProps} {...props}>
            <path
                fill="currentColor"
                d="M917.376 650.688V736h-170.688v170.688h-85.312v-256h256z m-256-266.688V128h85.312v170.688h170.688V384h-256zM384 384H128V298.688h170.688V128H384v256z m0 522.688H298.688V736H128v-85.312h256v256z"
            />
        </svg>
    );
}

/** 非全屏状态下的进入图标，对应旧 `quan-ping-svg.vue`。 */
export function FullscreenIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg {...baseProps} {...props}>
            <path
                fill="currentColor"
                d="M341.376 128v85.312H170.688V384H85.376V128h256z m-256 768v-256h85.312v170.688h170.688V896h-256z m853.312 0h-256v-85.312h170.688V640h85.312v256z m0-512h-85.312V213.312h-170.688V128h256v256z"
            />
        </svg>
    );
}
